export default __webpack_public_path__ + "static/media/fasting_ate@3x.73d31294.jpg";